import { combineReducers } from 'redux';

import languageReducer from './reducers/language.reducer';

export default combineReducers({
  language: languageReducer,
});
